<template>
  <el-row :gutter="15">
    <template v-for="(item, index) in cardList">
      <el-col :key="index" :xs="24" :lg="8">
        <el-card>
          <div class="stat-card">
            <div class="card-icon">
              <i :class="item.icon" :style="'color:'+item.color"></i>
            </div>
            <div class="card-description">
              <template v-if="Array.isArray(item.count)">
              <span v-for="(obj, index) in item.count" :key="index">
                <count-to :start-val='0' :end-val='obj.val' :duration='3000' :class="obj.color"></count-to>
                <span v-if="index < item.count.length-1">/</span>
              </span>
              </template>
              <template v-else>
                <count-to :start-val='0' :end-val='item.count' :duration='3000'></count-to>
              </template>
              <p>{{item.text}}</p>
            </div>
          </div>
        </el-card>
      </el-col>
    </template>
  </el-row>
</template>

<script>
  import CountTo from "vue-count-to";
  export default {
    name: "StatCard",
    props: {cardList: Array},
    components: {CountTo},
  }
</script>

<style scoped lang="scss">
  .stat-card {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .card-icon {
      i {
        font-size: 80px;
      }
    }
    .card-description {
      text-align: right;
      p {
        font-family: "Poppins",Poppins,Arial,sans-serif;
        font-size: 14px;
        color: #aab2bd;
      }
      span {
        font-size: 30px;
        font-weight: 500;
        color: #212121;
        font-family: "Poppins",Poppins,Arial,sans-serif;
      }
    }
  }
</style>
